import ActivityModel from "@/models/crm/ActivityModel";
import CrmServiceCollection from "../CrmServiceCollection";

export default class ActivityCollection extends CrmServiceCollection {
  model() {
    return ActivityModel;
  }
}